import React, { useRef, useCallback } from 'react';
import each from 'lodash/each';
import find from 'lodash/find';
import './style.scss';
function getNodeToFocus() {
    var nodeToFocus = null;
    each(document.querySelectorAll('.module'), function (module) {
        if (module.querySelector('nav'))
            return;
        var firstFocusableNode = getFirstFocusableNode(module);
        if (firstFocusableNode) {
            nodeToFocus = firstFocusableNode;
            return false;
        }
    });
    return nodeToFocus;
}
function getFirstFocusableNode(node) {
    var focusableNodes = node.querySelectorAll('a, button, iframe, [tabIndex="0"]');
    return find(focusableNodes, function (node) { return !node.classList.contains('hide') && node.tabIndex > -1; }) || null;
}
var NavFocusSkipper = function () {
    var firstMainContentNode = useRef(null);
    var skipToMainContent = useCallback(function () {
        var _a;
        if (!firstMainContentNode.current) {
            firstMainContentNode.current = getNodeToFocus();
        }
        try {
            (_a = firstMainContentNode.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        catch (e) {
            console.error('No actionable elements in main content');
        }
    }, []);
    return (React.createElement("a", { href: "#main", className: "skip-nav", onClick: skipToMainContent }, "Skip to main content"));
};
export default NavFocusSkipper;
